<script lang="ts">
    import {Link} from 'svelte-routing'
    import learnMore from 'src/components/main/#assets/learn-more.svg'
    import background from 'src/components/main/marketplace-seller/components/seller-intro/background.jpg'
    import {getNickname} from 'src/components/main/#services/account'

    export let userId

    getNickname.send({ data: { userId } })

    function avatar(nickname) {
        if (nickname) {
            return nickname.slice(0, 2)
        }
    }
</script>

<section class="main-intro">
    <div class="main-intro-content" style="background: #383e4c url({background}) no-repeat center;"></div>
</section>
<section class="user-info">
    <div class="container">
        <Link to="marketplace" class="back">
            <img src="{learnMore}" alt="">
            <span class="d-md-none">Back</span>
            <span class="d-none d-md-inline-block">To marketplace</span>
        </Link>
        {#if !$getNickname.hasValue && $getNickname.loading}
            <div class="avatar"></div>
            <div class="name">Loading...</div>
        {:else if !$getNickname.hasValue && $getNickname.error}
            <div class="avatar"></div>
            <div class="name">Error...</div>
        {:else if $getNickname.value}
            <div class="avatar">{avatar($getNickname.value)}</div>
            <div class="name">{$getNickname.value.replace(/#([^#]+)$/, '')}</div>
        {/if}
        <div class="description">See all of the seller's NFTs listed for sale on the Realis marketplace</div>
    </div>
</section>

<style>
    .user-info :global(.back) {
        color: white;
        font-size: 20px;
        font-family: 'Anton', sans-serif;
        display: table;
        position: absolute;
        top: 30px;
        text-decoration: none;
        text-transform: uppercase;
    }

    .user-info :global(.back img) {
        margin-right: 10px;
        transform: rotate(-90deg);
        transition: .25s;
    }

    .user-info :global(.back:hover img) {
        transform: rotate(-135deg);
    }

    .main-intro {
        position: relative;
        margin-top: 110px;
    }

    .main-intro:before {
        content: "";
        background: linear-gradient(219.76deg, rgba(87, 97, 215, 0.2) 22.71%, rgba(87, 97, 215, 0.14) 49.17%, rgba(87, 97, 215, 0) 77.29%);
        filter: blur(200px);
        width: 1050px;
        height: 437px;
        position: absolute;
        right: 120px;
        top: 20px;
    }

    .main-intro-content {
        position: relative;
        padding: 240px 0 0;
        background-size: cover !important;
        background-position: center !important;
        z-index: 2;
    }

    .user-info {
        position: relative;
        border-radius: 40px 40px 0 0;
        background: #02080b;
        margin-top: -40px;
        padding-bottom: 10px;
        z-index: 2;
    }

    .avatar {
        width: 132px;
        height: 132px;
        padding: 8px;
        background-color: #383e4c;
        transform: translate3d(-50%, -50%, 0px);
        border-radius: 50%;
        left: 50%;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border: 10px solid #02080b;
        color: #A0AEC0;
        font-size: 22px;
        text-transform: uppercase;
        user-select: none;
        cursor: default;
    }

    .name {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        position: relative;
        text-align: center;
        width: 100%;
        color: white;
        margin: -30px 0 20px;
    }

    .description {
        min-width: 0;
        overflow-wrap: break-word;
        white-space: normal;
        height: auto;
        overflow: hidden;
        max-width: 400px;
        width: auto;
        margin: 0 auto 20px;
        text-align: center;
        color: #A0AEC0;
        font-size: 16px;
        line-height: normal;
    }

    .main-intro-content .container {
        position: relative;
    }

    .intro-title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    @media (max-width: 1400px) {
        .intro-title br {
            display: none;
        }
    }

    @media (max-width: 991px) {
        .main-intro-content {
            padding: 180px 0 0;
        }

        .main-intro:before {
            display: none;
        }
    }

    @media (max-width: 767px) {
        .main-intro-content {
            padding: 130px 0 0;
        }

        .main-intro {
            margin-top: 62px;
        }

        .name {
            font-size: 18px;
            margin: -30px 0 15px;
        }

        .description {
            font-size: 14px;
        }

        .user-info {
            padding-bottom: 0;
            border-radius: 30px 20px 0 0;
        }

        .avatar {
            width: 80px;
            height: 80px;
            padding: 4px;
            border: 4px solid #02080b;
            font-size: 18px;
        }

        .user-info :global(.back) {
            top: 20px;
            left: 20px;
            font-size: 18px;
        }
    }
</style>
